import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/widgets";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import {
  MoreHorizontal, MessageCircle, Heart, Wallet, ParkingSquare, ShieldAlert, ShieldCheck,
  User, Crown, LayoutDashboard, LogOut, ChevronRight,
} from "lucide-react";

export default function More() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const items = [
    { icon: MessageCircle, label: "Ask VecPadi", to: "/app/assistant", color: "text-blue-600 bg-blue-50" },
    { icon: Heart, label: "Vehicle Health", to: "/app/health", color: "text-emerald-600 bg-emerald-50" },
    { icon: Wallet, label: "Expenses", to: "/app/expenses", color: "text-amber-600 bg-amber-50" },
    { icon: ParkingSquare, label: "Parking Finder", to: "/app/parking", color: "text-indigo-600 bg-indigo-50" },
    { icon: ShieldAlert, label: "Safety & SOS", to: "/app/safety", color: "text-red-600 bg-red-50" },
    { icon: ShieldCheck, label: "Insurance", to: "/app/insurance", color: "text-teal-600 bg-teal-50" },
    { icon: User, label: "Driver Profile", to: "/app/profile", color: "text-zinc-600 bg-zinc-100" },
  ];

  const doLogout = async () => { await logout(); navigate("/"); };

  return (
    <div className="space-y-6" data-testid="more-page">
      <PageHeader title="More" subtitle="Everything VecPadi can do." icon={MoreHorizontal} />

      {user?.plan !== "premium" && (
        <button onClick={() => navigate("/app/premium")} data-testid="more-upgrade"
          className="flex w-full items-center justify-between rounded-3xl bg-zinc-950 p-5 text-white transition-transform hover:-translate-y-0.5">
          <div className="flex items-center gap-3"><Crown size={22} className="text-emerald-400" /><div className="text-left"><div className="font-display font-bold">Go Premium</div><div className="text-xs text-zinc-400">Unlock everything from ₦1,250/mo</div></div></div>
          <ChevronRight />
        </button>
      )}

      <div className="space-y-2">
        {items.map((x) => (
          <button key={x.label} data-testid={`more-${x.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            onClick={() => navigate(x.to)}
            className="flex w-full items-center gap-4 rounded-2xl border border-zinc-200 bg-white p-4 transition-colors hover:bg-zinc-50">
            <div className={`grid h-10 w-10 place-items-center rounded-xl ${x.color}`}><x.icon size={20} /></div>
            <span className="flex-1 text-left text-sm font-medium text-zinc-800">{x.label}</span>
            <ChevronRight size={18} className="text-zinc-300" />
          </button>
        ))}
        {user?.role === "admin" && (
          <button data-testid="more-admin" onClick={() => navigate("/admin")}
            className="flex w-full items-center gap-4 rounded-2xl border border-zinc-200 bg-white p-4 hover:bg-zinc-50">
            <div className="grid h-10 w-10 place-items-center rounded-xl bg-zinc-900 text-white"><LayoutDashboard size={20} /></div>
            <span className="flex-1 text-left text-sm font-medium text-zinc-800">Admin Dashboard</span>
            <ChevronRight size={18} className="text-zinc-300" />
          </button>
        )}
      </div>

      <Button data-testid="more-logout" onClick={doLogout} variant="outline" className="w-full rounded-full text-red-600 border-red-200 hover:bg-red-50 gap-2">
        <LogOut size={16} /> Log out
      </Button>

      <div className="pt-4 text-center">
        <div className="flex justify-center"><Logo size={22} /></div>
        <p className="mt-2 text-xs text-zinc-400">Your car. Your safety. No wahala.</p>
      </div>
    </div>
  );
}
